import { useNavigate } from "react-router-dom";
import { useBilling } from "../context/BillingContext";
import { Sparkles, X, ArrowRight, Lock } from "lucide-react";

export default function UpgradeModal() {
  const { upgradeReason, dismissUpgrade, plan } = useBilling();
  const nav = useNavigate();
  if (!upgradeReason) return null;
  const goToBilling = () => { dismissUpgrade(); nav("/billing"); };

  return (
    <div className="fixed inset-0 bg-zinc-900/70 z-[60] flex items-center justify-center p-4" onClick={dismissUpgrade}>
      <div className="bg-white border border-zinc-200 w-full max-w-md" onClick={(e)=>e.stopPropagation()} data-testid="upgrade-modal">
        <div className="border-b border-zinc-200 p-5 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-[#FF3B30] flex items-center justify-center">
              <Lock className="w-5 h-5 text-white" />
            </div>
            <div>
              <div className="text-[10px] tracking-[0.25em] uppercase text-[#FF3B30] font-bold">Hit the ceiling</div>
              <div className="text-lg font-black tracking-tighter">Upgrade to keep going</div>
            </div>
          </div>
          <button onClick={dismissUpgrade} className="text-zinc-400 hover:text-zinc-900" data-testid="upgrade-close"><X className="w-5 h-5" /></button>
        </div>
        <div className="p-5 space-y-4">
          <p className="text-sm text-zinc-700">{upgradeReason.message}</p>
          <div className="border-l-4 border-[#0033FF] pl-3 py-1 text-xs text-zinc-500">
            You're currently on the <span className="font-bold text-zinc-900">{(upgradeReason.plan || plan).toUpperCase()}</span> plan.
          </div>
          <div className="flex flex-col sm:flex-row gap-2 pt-2">
            <button onClick={dismissUpgrade} className="border border-zinc-300 px-4 py-3 text-xs font-bold uppercase tracking-wider hover:bg-zinc-100 flex-1" data-testid="upgrade-not-now">
              Not now
            </button>
            <button onClick={goToBilling} className="bg-[#0033FF] text-white px-4 py-3 text-xs font-bold uppercase tracking-wider hover:bg-zinc-900 flex-1 inline-flex items-center justify-center gap-2" data-testid="upgrade-go">
              <Sparkles className="w-3.5 h-3.5" /> See plans <ArrowRight className="w-3.5 h-3.5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
